/**
 * Escapes HTML special characters to prevent XSS attacks.
 *
 * @param {string|null|undefined} text - The text to escape
 * @returns {string} - Escaped HTML-safe string
 */
export function escapeHtml(text) {
  if (text === null || text === undefined) return '';
  const str = String(text);
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return str.replace(/[&<>"']/g, (m) => map[m]);
}

/**
 * Escapes a value for safe use in an HTML attribute.
 * Same as escapeHtml but explicitly named for clarity.
 *
 * @param {string|null|undefined} text - The text to escape
 * @returns {string} - Escaped attribute-safe string
 */
export function escapeAttr(text) {
  return escapeHtml(text);
}
